module.exports = __webpack_public_path__ + "img/shield-green.1ae9ee95.svg";